// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"8d25dd9a","329":"6b82dac7","517":"50a2849f","787":"1b248a5d"}[chunkId] + ".chunk.js";
};